import ActionTypes from '../constants';

const initialState = {
    replaceableVehicles: {},
    replaceableVehicle: {},
};

const replaceableVehicleReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.GETREPLACEABLEVEHICLESUCCESS:
            return {
                ...state,
                replaceableVehicles: action.payload,
            }
        case ActionTypes.GETREPLACEABLEVEHICLEBYIDSUCCESS:
            return {
                ...state,
                replaceableVehicle: action.payload,
            }
        default:
            return state;
    }
}

export default replaceableVehicleReducer;